// Generated by scripts/generate-build-info.mjs
export const BUILD_INFO = {"buildId":"d3cbdeda6eddd42be361add97171646b49f5aaca","clientVersion":"test-d3cbdeda"} as const;
